module.exports = __webpack_public_path__ + "static/img/ai.d4ac9db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/door/ai.png
// module id = sNfR
// module chunks = 1